import { useGameStore } from '../state/store.js';
import type { InteractionMode } from '../state/store.js';

interface ToolbarProps {
  seed: number;
  onRegenerate: () => void;
}

const MODES: ReadonlyArray<{ id: InteractionMode; label: string; hint: string }> = [
  { id: 'camera', label: '🖐 Move', hint: 'Drag to pan the map' },
  { id: 'road', label: '🛤 Roads', hint: 'Drag to draw roads (workers prefer them)' },
  { id: 'spawn', label: '🧍 Spawn', hint: 'Click to spawn a worker' },
];

/** Top command bar: title, interaction mode, seed, pause, regenerate. */
export const Toolbar = ({ seed, onRegenerate }: ToolbarProps): React.JSX.Element => {
  const paused = useGameStore((s) => s.paused);
  const setPaused = useGameStore((s) => s.setPaused);
  const mode = useGameStore((s) => s.mode);
  const setMode = useGameStore((s) => s.setMode);
  const active = MODES.find((m) => m.id === mode);

  return (
    <header className="toolbar">
      <div className="brand">
        <span className="brand-mark">⚙</span>
        <span className="brand-name">SETTLERS RTS</span>
        <span className="brand-sprint">Sprint 2 · Roads &amp; Workers</span>
      </div>

      <div className="mode-group">
        {MODES.map((m) => (
          <button
            key={m.id}
            className={`btn mode-btn ${mode === m.id ? 'active' : ''}`}
            onClick={(): void => setMode(m.id)}
            title={m.hint}
          >
            {m.label}
          </button>
        ))}
        {active && <span className="mode-hint">{active.hint}</span>}
      </div>

      <div className="toolbar-actions">
        <span className="seed">
          seed&nbsp;<code>{seed}</code>
        </span>
        <button className="btn" onClick={(): void => setPaused(!paused)}>
          {paused ? '▶ Resume' : '⏸ Pause'}
        </button>
        <button className="btn btn-primary" onClick={onRegenerate}>
          ↻ New World
        </button>
      </div>
    </header>
  );
};
